import Phaser from 'phaser';
import { AudioManager } from '@/game/systems/AudioManager';
import { SaveManager } from '@/game/systems/SaveManager';

/** Creates the long-lived, non-scene-bound singletons and stashes them in the game
 * registry so any scene can pull them out (`this.game.registry.get('audioManager')`)
 * without prop-drilling through scene data payloads. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  create(): void {
    const saveManager = new SaveManager();
    const audioManager = new AudioManager();
    audioManager.setMusicVolume(saveManager.getSettings().musicVolume);
    audioManager.setSfxVolume(saveManager.getSettings().sfxVolume);

    this.game.registry.set('saveManager', saveManager);
    this.game.registry.set('audioManager', audioManager);

    const params = new URLSearchParams(window.location.search);
    if (params.get('editor') === 'true') {
      this.scene.start('ChartEditorScene');
    } else {
      this.scene.start('PreloadScene');
    }
  }
}
